import {
  Bike,
  Box,
  BriefcaseBusiness,
  CarFront,
  Crown,
  Gem,
  ShieldCheck,
  Sparkles,
  Users,
} from 'lucide-react';

export const rideCategories = [
  {
    name: 'Mini',
    summary: 'Simple, efficient city travel for everyday plans.',
    icon: CarFront,
    tone: 'mint',
  },
  {
    name: 'Economy',
    summary: 'Comfortable daily rides with practical value.',
    icon: CarFront,
    tone: 'blue',
  },
  {
    name: 'Premium',
    summary: 'Extra comfort for workdays and important journeys.',
    icon: Gem,
    tone: 'violet',
  },
  {
    name: 'Luxury',
    summary: 'A refined ride experience for special occasions.',
    icon: Crown,
    tone: 'gold',
  },
  {
    name: 'Bike',
    summary: 'A nimble option for quick movement through the city.',
    icon: Bike,
    tone: 'coral',
  },
  {
    name: 'Rickshaw',
    summary: 'A familiar local option for short urban journeys.',
    icon: Users,
    tone: 'mint',
  },
];

export const services = [
  {
    eyebrow: 'Move around',
    title: 'City & intercity rides',
    description:
      'Choose a category for local or city-to-city travel, then follow a clear request and matching flow.',
    icon: CarFront,
    to: '/services/rides',
    cta: 'Explore ride options',
    tone: 'violet',
  },
  {
    eyebrow: 'Send locally',
    title: 'Within-city courier',
    description:
      'A structured sender-to-recipient flow for eligible items moving within the same city.',
    icon: Box,
    to: '/services/courier',
    cta: 'See courier service',
    tone: 'coral',
  },
  {
    eyebrow: 'Build together',
    title: 'Captain opportunities',
    description:
      'A guided registration and review experience for eligible drivers and vehicle owners.',
    icon: BriefcaseBusiness,
    to: '/captains',
    cta: 'Drive with Sawwari',
    tone: 'mint',
  },
];

export const trustPoints = [
  {
    icon: ShieldCheck,
    title: 'Reviewed captain profiles',
    text: 'Captain identity, vehicle and required documents are reviewed before account approval.',
  },
  {
    icon: Sparkles,
    title: 'Clear choices',
    text: 'Service categories and key journey information are presented before a request is confirmed.',
  },
  {
    icon: Users,
    title: 'Local support path',
    text: 'Trip and courier concerns can be raised through a traceable support and complaints flow.',
  },
];

export const captainSteps = [
  {
    number: '01',
    title: 'Create one secure account',
    text: 'Register with your mobile number and core account details, then complete OTP verification.',
  },
  {
    number: '02',
    title: 'Complete your profile',
    text: 'Add identity, address, licence, vehicle and ownership information in a guided flow.',
  },
  {
    number: '03',
    title: 'Submit documents',
    text: 'Upload clear document images and submit the profile for administrative review.',
  },
  {
    number: '04',
    title: 'Enter the Departure Lounge',
    text: 'After approval, move into the ride-receiving experience and manage future document updates.',
  },
];

export const safetyItems = [
  {
    title: 'Account and identity controls',
    text: 'OTP, secure credentials and supported device biometrics help protect account access.',
  },
  {
    title: 'Document review',
    text: 'Captain and vehicle documentation follows a review, rejection-reason and re-upload process.',
  },
  {
    title: 'Journey records',
    text: 'Ride, courier, account and support activity can be retained as traceable platform records.',
  },
  {
    title: 'Emergency direction',
    text: 'The safety experience is designed to make Pakistan emergency contact guidance easy to find.',
  },
];
